import { UnitsManagementConst } from '@featureModule/units-management/consts';

/**
 * Local alias for the Facility child const to keep mapper expressions concise.
 */
const FACILITY_CONST = UnitsManagementConst.CHILDREN.FACILITY;

/**
 * Translate key mapper for the Facility view component.
 * All keys are functions so they re-evaluate after a language switch.
 */
export const FacilityTranslateMapper = {

    /** Returns the i18n key for the Facility page title. */
    TITLE: () => `${FACILITY_CONST.TRANSLATE_KEY()}.TITLE`,

    /** Returns the i18n key for the Facility menu label. */
    MENU_LABEL: () => `${FACILITY_CONST.TRANSLATE_KEY()}.MENU_LABEL`,

    /** Form field translation keys. */
    FORM: {

        /** Returns the i18n key for the form section title. */
        TITLE: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.TITLE`,

        FACILITY_NAME: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.FACILITY_NAME.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.FACILITY_NAME.PLACEHOLDER`,
        },
        FACILITY_TYPE: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.FACILITY_TYPE.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.FACILITY_TYPE.PLACEHOLDER`,
        },
        BUILDING_NO: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.BUILDING_NO.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.BUILDING_NO.PLACEHOLDER`,
        },
        STREET: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.STREET.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.STREET.PLACEHOLDER`,
        },
        DISTRICT: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.DISTRICT.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.DISTRICT.PLACEHOLDER`,
        },
        CITY: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.CITY.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.CITY.PLACEHOLDER`,
        },
        ZIP: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.ZIP.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.ZIP.PLACEHOLDER`,
        },
        ADDITIONAL_NO: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.ADDITIONAL_NO.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.ADDITIONAL_NO.PLACEHOLDER`,
        },
        UNIT: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.UNIT.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.UNIT.PLACEHOLDER`,
        },
        LATITUDE: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.LATITUDE.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.LATITUDE.PLACEHOLDER`,
        },
        LONGITUDE: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.LONGITUDE.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.LONGITUDE.PLACEHOLDER`,
        },
        X_COORDINATE: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.X_COORDINATE.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.X_COORDINATE.PLACEHOLDER`,
        },
        Y_COORDINATE: {
            LABEL:       () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.Y_COORDINATE.LABEL`,
            PLACEHOLDER: () => `${FACILITY_CONST.TRANSLATE_KEY()}.FORM.Y_COORDINATE.PLACEHOLDER`,
        },

    },

};
